import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { CustomerGroupResource } from "@exonn/js-sdk";

export const module: ModuleOptions<CustomerGroupResource> = {
  resource: ResourceEnum.CustomerGroup,
  bigIcon: <i className="icon-20-customers_grp_adm" />,
  smallIcon: <i className="icon-15-customers_grp_adm" />,
};
